import { Record } from 'immutable';
import { actionTypes } from './change-password.actions';
import { Err } from '../../err';
import { passwordUtilities } from '../../common';

export const changePasswordState = Record({
  err: null,
  warn: '',
  isFetching: false,
  passwordRulesValid: false
});

export const changePasswordReducer = (state = new changePasswordState(), action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      return new changePasswordState();
    case actionTypes.CREATE_NEW_PASSWORD_BEGIN:
      return state.set('err', null)
                  .set('isFetching', true);
    case actionTypes.CREATE_NEW_PASSWORD_SUCCESS:
      return state.set('err', null)
                  .set('isFetching', false);
    case actionTypes.CREATE_NEW_PASSWORD_FAILURE:
      return state.set('err', new Err(action.err))
                  .set('isFetching', false);
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/acct/password/change-password.reducer.js